

export default function Cancel() {
    return(
        <div>취소함.</div>
    )
}